import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase/client';
import { User } from '@supabase/supabase-js';

interface UserData {
  user: User | null;
  loading: boolean;
}

export const useUser = (): UserData => {
  const [userData, setUserData] = useState<UserData>({
    user: null,
    loading: true,
  });

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        console.log('Auth state change:', event, session);
        setUserData({
          user: session?.user || null,
          loading: false,
        });
      }
    );

    // Get initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      console.log('Initial session:', session);
      setUserData({
        user: session?.user || null,
        loading: false,
      });
    });

    return () => {
      authListener?.subscription.unsubscribe();
    };
  }, []);

  return userData;
};

export default useUser;
